import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);
const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err);
};

// 路由白名单
var routerUlrWhite = [
  "/404",
  "/",
  "/login",
  "/rescueWorkOrder",
  "/personalInformation",
  "/monitor-rundataNew",
  "/third/outVideo",
  "/leOut",
  "/homePage",
  "/multipleMonitor",
  "/elevator-kanban"
];

const router = new Router({
  routes: [
    {
      path: "/home",
      name: "Home",
      component: () => import("@/components/Home/Home.vue"),
      children: [
        // {      //主页
        // 	path: '/homePage',
        // 	name: 'homePage',
        // 	component: () => import('@/components/homePage/homePage.vue')
        // },

        {
          path: "/test",
          name: "test",
          component: () => import("@/components/test/test.vue")
        },

        // {  //电梯信息管理
        //   path: '/record-management-elevator',
        //   name: 'record-management-elevator',
        //   component: () => import('@/components/elevatorInformationManagement/elevatorInformationManagement.vue')
        // },

        {
          //个人中心
          path: "/personalInformation",
          name: "personalInformation",
          component: () =>
            import("@/components/personalInformation/personalInformation.vue")
        },

        // 新版===================================================================================================

        {
          // 故障历史纪录
          path: "/fault-history",
          name: "fault-history",
          component: () => import("@/pages/waitSolut/faultHistory.vue")
        },

        {
          // 安装单位管理
          path: "/unit-management-install",
          name: "unit-management-install",
          component: () => import("@/pages/unitManagement/install.vue")
        },

        {
          // 物业单位管理
          path: "/unit-management-property",
          name: "unit-management-property",
          component: () => import("@/pages/unitManagement/property.vue")
        },
        {
          // 监管单位管理
          path: "/unit-regulator",
          name: "unit-regulator",
          component: () => import("@/pages/unitManagement/regulator.vue")
        },
        {
          //电梯品牌
          path: "/unit-management-manufacture",
          name: "unit-management-manufacture",
          component: () => import("@/pages/unitManagement/manufacturer.vue")
        },
        {
          // 授权信息
          path: "/auth-management-info",
          name: "auth-management-info",
          component: () => import("@/pages/authManagement/info.vue")
        },
        {
          // 授权机构
          path: "/auth-management-org",
          name: "auth-management-org",
          component: () => import("@/pages/authManagement/org.vue")
        },
        {
          // 授权模块
          path: "/auth-management-module",
          name: "auth-management-module",
          component: () => import("@/pages/authManagement/module.vue")
        },
        {
          // 授权接口
          path: "/auth-management-interface",
          name: "auth-management-interface",
          component: () => import("@/pages/authManagement/interface.vue")
        },
        {
          // 角色管理
          path: "/power-management-role",
          name: "power-management-role",
          component: () => import("@/pages/powerManagement/role.vue")
        },
        {
          // 用户管理
          path: "/power-management-user",
          name: "power-management-user",
          component: () => import("@/pages/powerManagement/user.vue")
        },

        // 基础资料管理=========================================================
        {
          //单位管理
          path: "/baseinfo-unit",
          name: "baseinfo-unit",
          component: () => import("@/pages/baseinfo/unit.vue")
        },
        {
          //部门管理
          path: "/baseinfo-org",
          name: "baseinfo-org",
          component: () => import("@/pages/baseinfo/unit.vue")
        },
        {
          //小区管理
          path: "/baseinfo-project",
          name: "baseinfo-project",
          component: () => import("@/pages/baseinfo/project.vue")
        },
        {
          //电梯管理
          path: "/baseinfo-elevator",
          name: "baseinfo-elevator",
          component: () => import("@/pages/baseinfo/elevator.vue")
        },
        {
          //维保单位管理
          path: "/baseinfo-maintcompany",
          name: "baseinfo-maintcompany",
          component: () => import("@/pages/baseinfo/maintcompany.vue")
        },
        // 智能设备管理=================================================
        {
          //智能设备
          path: "/smartdevice-smartdevice",
          name: "smartdevice-smartdevice",
          component: () => import("@/pages/smartdevice/smartdevice.vue")
        },
        // 电梯监控管理=================================================
        {
          //运行监测
          path: "/monitor-rundata",
          name: "monitor-rundata",
          component: () => import("@/pages/monitor/rundata.vue")
          // component: () => import('@/components/realTimeDataMonitoring/realTimeDataMonitoring.vue')
        },
        {
          //运行监测
          path: "/monitor-rundata-v2",
          name: "monitor-rundata-v2",
          component: () => import("@/pages/monitor/rundataNew.vue")
          // component: () => import('@/components/realTimeDataMonitoring/realTimeDataMonitoring.vue')
        },

        {
          //多梯监控
          path: "/monitor-multi",
          name: "monitor-multi",
          component: () => import("@/pages/404/404.vue")
        },
        // 终端告警管理=================================================
        // {  //接警处置中心（原带处置工单）
        //   path: '/alarm-dealcenter',
        //   name: 'alarm-dealcenter',
        //   component: () => import('@/pages/alarm/dealcenter.vue')
        // },
        // {  //故障告警记录
        //   path: '/alarm-faulthistory',
        //   name: 'alarm-faulthistory',
        //   component: () => import('@/pages/alarm/faulthistory.vue')
        // },
        {
          //故障告警记录
          path: "/alarm",
          name: "alarm",
          component: () => import("@/pages/alarm/faulthistory.vue")
        },
        {
          //事件告警记录
          path: "/alarm-eventhistory",
          name: "alarm-eventhistory",
          component: () => import("@/pages/404/404.vue")
        },
        // 电梯保养=================================================
        {
          //保养项目设置
          path: "/maintain-option",
          name: "maintain-option",
          component: () => import("@/pages/maintain/option.vue")
        },
        {
          //保养模板设置
          path: "/maintain-template",
          name: "maintain-template",
          component: () => import("@/pages/maintain/template.vue")
        },
        {
          //保养计划设置
          path: "/maintain-plan",
          name: "maintain-plan",
          component: () => import("@/pages/maintain/plan.vue")
        },
        //工单任务管理=================================================
        {
          //工单组配置
          path: "/work-order-group",
          name: "work-order-group",
          component: () => import("@/pages/work-order/group.vue")
        },
        {
          //救援工单
          path: "/work-order-rescue",
          name: "work-order-rescue",
          component: () => import("@/pages/work-order/rescue.vue")
        },
        {
          //保养工单
          path: "/work-order-maintain",
          name: "work-order-maintain",
          component: () => import("@/pages/work-order/maintain.vue")
        },
        {
          //年检提醒
          path: "/inspection-notify",
          name: "inspection-notify",
          component: () => import("@/pages/work-order/inspection.vue")
        },
        {
          //维修工单
          path: "/work-order-repair",
          name: "work-order-repair",
          component: () => import("@/pages/work-order/repair.vue")
        },
        {
          //调试工单
          path: "/work-order-debugging",
          name: "work-order-debugging",
          component: () => import("@/pages/work-order/debugOrder.vue")
        },
        {
          //安装工单
          path: "/work-order-elevator",
          name: "work-order-elevator",
          component: () => import("@/pages/work-order/debugging.vue")
        },
        //物业公告管理=================================================
        {
          //公告管理
          path: "/project-notice-management",
          name: "project-notice-management",
          component: () => import("@/pages/project-notice/management2.vue")
        },
        {
          //公告审批
          path: "/project-notice-approval",
          name: "project-notice-approval",
          component: () => import("@/pages/project-notice/approval.vue")
        },
        {
          //发布历史
          path: "/project-notice-history",
          name: "project-notice-history",
          component: () => import("@/pages/404/404.vue")
        },
        //系统日志管理=================================================
        {
          //系统操作日志
          path: "/syslog-history",
          name: "syslog-history",
          component: () => import("@/pages/system/sysHistory.vue")
        },
        //系统配置管理=================================================
        {
          //升级管理
          path: "/system-upgrade",
          name: "system-upgrade",
          component: () => import("@/pages/404/404.vue")
        },
        {
          //告警配置
          path: "/system-alarmSetting",
          name: "system-alarmSetting",
          component: () => import("@/pages/system/alarmSetting.vue")
        },
        {
          //数据字典
          path: "/system-dict",
          name: "system-dict",
          component: () => import("@/pages/system/dict.vue")
        },
        {
          //APP管理
          path: "/system-app",
          name: "system-app",
          component: () => import("@/pages/system/app.vue")
        },
        {
          //智泉二维码上传
          path: "/system-zhiq-qrcode",
          name: "system-zhiq-qrcode",
          component: () => import("@/pages/system/zhiq-qrcode.vue")
        },

        {
          path: "/rescueWorkOrder",
          name: "rescueWorkOrder",
          component: () => import("@/pages/work-order/rescueWorkOrder.vue")
        },
        {
          //homePage主页
          path: "/property-monitor-index",
          name: "homePage",
          component: () => import("@/pages/homePage/homePage.vue")
        },
        {
          //现在统计
          path: "/data-statistic-online",
          name: "onlineRate",
          component: () => import("@/pages/dataStats/onlineRate.vue")
        },
        {
          //多梯监控
          // path: '/multipleMonitor',
          path: "/multiple-monitoring",
          name: "multipleMonitor",
          component: () => import("@/pages/monitor/multipleMonitor.vue")
        },
        {
          //运行数据控制台
          path: "/data-monitor",
          name: "dataMonitor",
          component: () => import("@/pages/alarm/dataMonitor.vue")
        }
      ]
    },
    //看板 电梯运营 新
    {
      path: "/elevator-kanban",
      name: "elevator-kanban",
      component: () => import("@/pages/elevatorKanban/elevatorKanban.vue")
    },
    // 数据看板-城市看板
    {
      path: "/city-Kanban",
      name: "city-Kanban",
      component: () => import("@/pages/dataBoard/cityKanban.vue")
    },
    // 城市看板
    {
      path: "/big-screen",
      name: "big-screen",
      // component: () => import('@/pages/bigScreen/bigScreen.vue')
      component: () => import("@/pages/dataBoard/cityKanban.vue")
    },
    // 大数据看板
    {
      path: "/bigDataBord",
      name: "bigDataBord",
      component: () => import("@/components/bigDataBord/bigDataBord.vue")
    },
    {
      path: "/",
      name: "login",
      component: () => import("@/components/login/login.vue")
    },
    // {  //电梯监控详情
    //   path: '/elevatordetails',
    //   name: 'elevatordetails',
    //   component: () => import('@/components/elevatordetails/elevatordetails.vue')
    // },
    // 外部链接过来监控视频
    {
      path: "/third/outVideo",
      name: "outVideo",
      component: () => import("@/pages/outVideo/outVideo.vue")
    },
    //曹老师外置摄像头查看录像
    {
      path: "/leOut",
      name: "leOut",
      component: () => import("@/pages/leOut/leOut.vue")
    }
  ]
});

// 全局路由守卫
router.beforeEach((to, from, next) => {
  console.log(router.app.$options.store.state.urlOnlyArr);
  if (
    router.app.$options.store.state.urlOnlyArr &&
    router.app.$options.store.state.urlOnlyArr.length != 0
  ) {
    if (
      router.app.$options.store.state.urlOnlyArr.indexOf(
        to.path.replace("/", "")
      ) == -1 &&
      routerUlrWhite.indexOf(to.path) == -1
    ) {
      router.app.$message({
        message: "您没有此页面权限，请联系管理员",
        type: "warning"
      });
      next(from.path);
    } else {
      next();
    }
  } else {
    next();
  }
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js